export default __webpack_public_path__ + "static/media/Bert.f601cbfe.png";